<template>
	<helio-field
		:placeholder="placeholder"
		:large="true"
		class="table__search"
		icon="search"
		icon-weight="light"
		@changed="debounceTermChanged"
	/>
</template>

<script>
import _debounce from 'lodash/debounce';
import Field from '../../field/Field.vue';

export default {
	components: {
		'helio-field': Field,
	},

	props: {
		placeholder: {
			type: String,
			required: true,
		},
	},

	methods: {
		/* eslint-disable-next-line */
		debounceTermChanged: _debounce(function (newValue) {
			this.$emit('search', newValue);
		}, 100),
	},
};
</script>

<style lang="text/scss" src="./search.scss" />
